<ion-card mode="ios" color="getm-neutral-white" class="card-content-promo" (click)="onPromoClick()">
  <!-- ! Marcas -->
  <ion-card mode="md" color="getm-information-light" class="card-brands">
    <!-- * TAG Exclusivo -->
    <ng-container *ngIf="promoData.Exclusivo">
      <section class="m-tag-card-exclusive">
        <getm-tag-card-product
          [label]="'Labels.only-app' | translate"
          [color]="'getm-primary-default'"
          corners="tl br"
          fill="solid"
        ></getm-tag-card-product>
      </section>
    </ng-container>

    <!-- * TAG Promocion -->
    <section class="m-tag-card-promo">
      <getm-tag-card-product
        [icon]="
          promoData.Bonificacion ? 'getm-gift-fill' : 'getm-discount-fill'
        "
        [label]="
          (promoData.Bonificacion ? 'Labels.bonus' : 'Titles.promotions')
            | translate
        "
        [color]="'getm-category-especiales-del-mes'"
        corners="tr bl"
        fill="outline"
      ></getm-tag-card-product>
    </section>

    <ion-icon
      [name]="promoData.Bonificacion ? 'getm-gift-fill' : 'getm-discount-fill'"
      color="getm-neutral-hover"
      class="bg-icon"
    ></ion-icon>

    <ng-container *ngIf="promoData.imagen_url; else Marcas">
      <img
        [src]="promoData.imagen_url"
        [alt]="promoData.Promocion"
        class="img-promo"
      />
    </ng-container>

    <ng-template #Marcas>
      <ion-row
        class="row-content-brands ion-align-items-center ion-justify-content-center"
      >
        <ng-container
          *ngFor="
            let marca of promoData.Marcas | slice : 0 : 6;
            trackBy: trackByMarca;
            let i = index;
            last as isLast
          "
        >
          <ion-col
            [size]="promoData.Marcas.length < 5 ? 3 : 4"
            class="ion-no-padding"
          >
            <ng-container
              *ngIf="promoData.Marcas.length > 6 && isLast; else imagesBrands"
            >
              <ion-thumbnail class="thumbnail-brand-more">
                <ion-icon
                  name="ellipsis-horizontal"
                  color="getm-category-especiales-del-mes"
                ></ion-icon>
              </ion-thumbnail>
            </ng-container>
            <ng-template #imagesBrands>
              <ion-thumbnail
                class="thumbnail-brand"
                [ngStyle]="{
                  '--size':
                    promoData.Marcas.length < 2
                      ? '64px'
                      : promoData.Marcas.length < 3
                      ? '55px'
                      : promoData.Marcas.length < 5
                      ? '40px'
                      : '32px'
                }"
              >
                <ion-img [src]="marca.URL_Imagen" [alt]="marca.Marca" />
              </ion-thumbnail>
            </ng-template>
          </ion-col>
        </ng-container>
      </ion-row>
    </ng-template>
  </ion-card>

  <ion-list mode="ios" class="promo-content">
    <!-- * Titulo -->
    <ion-item mode="md" color="transparent" lines="none">
      <ion-label color="getm-neutral-dark" class="title-promo mpe-ellipsis-two">
        {{ promoData.Promocion }}
      </ion-label>
    </ion-item>

    <!-- ! Detalle por tipo promo -->
    <ion-item mode="md" color="transparent" lines="none" class="item-labels">
      <ng-container
        *ngIf="
          promoData.puntos_recompepsi || promoData.muestra_texto_generico_puntos
        "
      >
        <section slot="start" class="ion-no-margin">
          <getm-coins-badge
            [size]="promoData.muestra_texto_generico_puntos ? 'small' : 'large'"
            [text]="
              promoData.muestra_texto_generico_puntos
                ? ('Labels.earn-points' | translate)
                : '+' + promoData.puntos_recompepsi
            "
          ></getm-coins-badge>
        </section>
      </ng-container>

      <section slot="end" class="ion-no-margin">
        <getm-promo-tag-sale [promo]="promoData"></getm-promo-tag-sale>
      </section>
    </ion-item>

    <!-- ! Acciones -->
    <ion-item mode="md" color="transparent" lines="none" class="item-actions">
      <ion-grid fixed class="ion-no-padding">
        <ion-row class="ion-justify-content-between ion-align-items-center">
          <ion-col size="5">
            <ng-container
              *ngIf="
                promoData.MaximoPaquetes - promoData.PaquetesCanjeados > 0;
                else soldOut
              "
            >
              <getm-left-label-card
                [text]="
                  'Labels.available-and-ends-v2'
                    | translate
                      : {
                          available:
                            promoData.MaximoPaquetes -
                            promoData.PaquetesCanjeados,
                          ends: promoData.Vigencia
                        }
                "
              ></getm-left-label-card>
            </ng-container>

            <!-- * Slider -->
            <ng-template #soldOut>
              <ng-container
                *ngIf="(quantityExtras$ | async) > 0; else withoutExtras"
              >
                <ng-container *ngTemplateOutlet="swiperTemplate"></ng-container>
              </ng-container>
              <ng-template #withoutExtras>
                <ng-container *ngTemplateOutlet="limitReached"></ng-container>
              </ng-template>
            </ng-template>
          </ion-col>

          <ion-col size="6.7">
            <section class="actions-buttons" (click)="$event.stopPropagation()">
              <ng-container [ngSwitch]="promoData.TipoPromocion">
                <ng-container *ngSwitchCase="'ESTATICO'">
                  <ng-container *ngIf="quantity < 1; else selectorQuantity">
                    <getm-button
                      [text]="'Buttons.add' | translate"
                      color="primary"
                      size="default"
                      expand="block"
                      [disabled]="
                        promoData.MaximoPaquetes -
                          promoData.PaquetesCanjeados <=
                        0
                      "
                      (btnClick)="onBuildPromo()"
                    ></getm-button>
                  </ng-container>

                  <ng-template #selectorQuantity>
                    <getm-quantity-selector
                      [quantity]="quantity"
                      [minimo]="1"
                      [maximo]="
                        promoData.Productos.length === 1
                          ? ('RangeSelector.Store.end' | translate)
                          : promoData.MaximoPaquetes
                      "
                      [showRemoveBtn]="true"
                      fill="solid"
                      (quantityChange)="onQuantityChange($event)"
                    ></getm-quantity-selector>
                  </ng-template>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <getm-button
                    [text]="'Buttons.build-promotion' | translate"
                    color="primary"
                    size="default"
                    expand="block"
                    [disabled]="
                      promoData.MaximoPaquetes - promoData.PaquetesCanjeados < 0
                    "
                    (btnClick)="onBuildPromo()"
                  ></getm-button>
                </ng-container>
              </ng-container>
            </section>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </ion-list>
</ion-card>

<!-- ? Swiper de advertencias -->
<ng-template #swiperTemplate>
  <section class="section-swiper-container">
    <ion-grid class="ion-no-padding component-slider-box">
      <section
        class="slider-wrapper"
        [style.transform]="'translateY(-' + activeSlide * 50 + '%)'"
      >
        <ion-row class="slide-item">
          <ion-col size="12">
            <ng-container
              *ngTemplateOutlet="withoutExtrasMessage"
            ></ng-container>
          </ion-col>
        </ion-row>

        <ion-row class="slide-item">
          <ion-col size="12">
            <ng-container *ngTemplateOutlet="limitReached"></ng-container>
          </ion-col>
        </ion-row>
      </section>
    </ion-grid>
  </section>
</ng-template>

<!-- ? Mensaje de límite alcanzado -->
<ng-template #limitReached>
  <getm-left-label-card
    icon="getm-warning-fill"
    iconColor="getm-warning-default"
    [text]="'Labels.limit-reached' | translate"
    colorBg="getm-warning-light"
  ></getm-left-label-card>
</ng-template>

<!-- ? Mensaje de paquetes adicionales sin descuento -->
<ng-template #withoutExtrasMessage>
  <getm-left-label-card
    icon="getm-warning-fill"
    iconColor="getm-warning-default"
    [text]="
      'Labels.packages-added-without-discount'
        | translate : { quantityExtras: (quantityExtras$ | async) }
    "
    colorBg="getm-warning-light"
  ></getm-left-label-card>
</ng-template>
